import { useMemo } from 'react';
import { Tag } from 'antd';
import { FaMars, FaVenus, FaGenderless } from 'react-icons/fa';

export const useGenderRender = () => {
  return useMemo(() => {
    return (gender: string) => {
      const genderConfigs: {
        [key: string]: { 
          bgColor: string; 
          textColor: string; 
          borderColor: string;
          icon: React.ReactNode; 
          text: string 
        };
      } = {
        MALE: { 
          bgColor: '#e6f7ff', 
          textColor: '#1890ff', 
          borderColor: '#91d5ff',
          icon: <FaMars />, 
          text: 'Male' 
        },
        FEMALE: { 
          bgColor: '#fff0f6', 
          textColor: '#eb2f96', 
          borderColor: '#ffadd2',
          icon: <FaVenus />, 
          text: 'Female' 
        },
        OTHER: { 
          bgColor: '#fafafa', 
          textColor: '#8c8c8c', 
          borderColor: '#d9d9d9',
          icon: <FaGenderless />, 
          text: 'Other' 
        },
      };

      const config = genderConfigs[gender] || { 
        bgColor: '#f5f5f5', 
        textColor: '#8c8c8c', 
        borderColor: '#d9d9d9',
        icon: <FaGenderless />, 
        text: gender 
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
